import { useCallback } from "react";
import {
  triggerExperienceGain,
  EXPERIENCE_GAINS
} from "stores/experienceGainStore";

/**
 * Hook to easily trigger experience gains throughout the application
 */
export const useExperienceGain = () => {
  const gainExperience = useCallback((amount: number, reason?: string) => {
    triggerExperienceGain(amount, reason);
  }, []);

  // Common experience gain actions
  const actions = useCallback(
    () => ({
      likeMessage: () =>
        gainExperience(EXPERIENCE_GAINS.LIKE_MESSAGE, "Message liked"),
      sendMessage: () =>
        gainExperience(EXPERIENCE_GAINS.SEND_MESSAGE, "Message sent"),
      createPost: () =>
        gainExperience(EXPERIENCE_GAINS.CREATE_POST, "Post created"),
      completeTask: () =>
        gainExperience(EXPERIENCE_GAINS.COMPLETE_TASK, "Task completed"),
      dailyLogin: () =>
        gainExperience(EXPERIENCE_GAINS.DAILY_LOGIN, "Daily login"),
      firstLogin: () =>
        gainExperience(EXPERIENCE_GAINS.FIRST_LOGIN, "Welcome!"),
      completeProfile: () =>
        gainExperience(EXPERIENCE_GAINS.COMPLETE_PROFILE, "Profile completed"),
      receiveAppreciation: () =>
        gainExperience(
          EXPERIENCE_GAINS.RECEIVE_APPRECIATION,
          "Appreciation received"
        ),
      giveAppreciation: () =>
        gainExperience(
          EXPERIENCE_GAINS.GIVE_APPRECIATION,
          "Appreciation given"
        ),
      createRequest: () =>
        gainExperience(EXPERIENCE_GAINS.CREATE_REQUEST, "Request created"),
      createAppreciation: () =>
        gainExperience(
          EXPERIENCE_GAINS.CREATE_APPRECIATION,
          "Appreciation created"
        ),
      createCareer: () =>
        gainExperience(EXPERIENCE_GAINS.CREATE_CAREER, "Career created"),
      createItemPath: () =>
        gainExperience(EXPERIENCE_GAINS.CREATE_ITEM_PATH, "Item path created"),
      createOffer: () =>
        gainExperience(EXPERIENCE_GAINS.CREATE_OFFER, "Offer created"),
      createApplicant: () =>
        gainExperience(EXPERIENCE_GAINS.CREATE_APPLICANT, "Applicant created"),
      moveApplicant: () =>
        gainExperience(EXPERIENCE_GAINS.MOVE_APPLICANT, "Applicant moved")
    }),
    [gainExperience]
  );

  return {
    gainExperience,
    actions: actions()
  };
};
